import React, { useContext } from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import useNotification from 'shared/hooks/useNotification';
import ThemeContext from 'shared/context/ThemeContext';
import { onPressHelp } from 'shared/utils/redirectionHelp';
import Modal from '../JSModal';
import Button from '../Button/Button';
import {
  ActionsContainer,
  HeaderContainer,
  HeaderContent,
  HelpText,
  HelpTextContainer,
  Message,
  ModalContainer,
  ModalContent,
  ModalMainBodyStyle,
  SocialModalStyle,
  Title,
  TitleContainer,
} from './styledComponents';

const NotificationModal = () => {
  const { clearNotification, notification } = useNotification();
  const {
    title,
    message,
    button,
    buttonAction = null,
    hideCloseButton = false,
    hideHelpButton = false,
    hasCancelButton = false,
  } = notification;
  const { NotificationModal } = useContext(ThemeContext);

  const handleButtonAction = () => {
    buttonAction && buttonAction();
    (!hideCloseButton || hasCancelButton) && clearNotification();
  };

  return (
    <Modal
      customBackground
      hideCloseButton={hideCloseButton}
      hideOverlay={false}
      isVisible={!!notification}
      modalMainBodyStyle={ModalMainBodyStyle}
      onBackButtonPress={() => (!hideCloseButton || hasCancelButton) && clearNotification()}
      style={SocialModalStyle}
      zIndex={99999}
    >
      <ModalContainer>
        <HeaderContainer
          ibw={require(asset`Full_Modal_Header.ibw`)}
          position="absolute"
          source={require(asset`Full_Modal_Header.png`)}
          theme={NotificationModal.HeaderContainer}
        >
          <HeaderContent>
            <TitleContainer>
              <Title>{title}</Title>
            </TitleContainer>
            {!hideHelpButton && (
              <HelpTextContainer onClick={onPressHelp}>
                <HelpText>{getText(TEXT_KEY.NEED_HELP)}</HelpText>
              </HelpTextContainer>
            )}
          </HeaderContent>
        </HeaderContainer>
        <ModalContent withButton={!!button}>
          <Message>{message}</Message>
          <ActionsContainer>
            {button && (
              <Button
                imageSource={require(asset`RoundedRect_Pink@3x.png`)}
                onClick={handleButtonAction}
                label={button}
              />
            )}
            {hasCancelButton && (
              <Button
                imageSource={require(asset`RoundedRect_Red@3x.png`)}
                onClick={clearNotification}
                label={getText(TEXT_KEY.NOTIFICATION_MODAL_CANCEL)}
              />
            )}
          </ActionsContainer>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default NotificationModal;

